module.exports = __webpack_public_path__ + "media/application/images/svgs/disc-59bf05d8060b802d96e61029342f8960.svg";